import { Injectable } from '@angular/core';
import { ILookupHttpService, LookupGridResult, RemoteParams } from '@farris/ui-lookup';
import { HttpService } from '@ecp-caf/caf-common';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

@Injectable()
export class ComponentEditLookUpService implements ILookupHttpService {
    constructor(
        private http: HttpService,
    ) {
    }

    getData(url: string, params?: RemoteParams): Observable<any> {
        const customData = params.customData;
        const index = params.pageIndex || 1;
        const size = params.pageSize || 20;
        const searchValue = params.searchValue;
        if (customData.helpId) {
            let query = `?helpId=${customData.helpId}&pageIndex=${index}&pageSize=${size}`;
            if (searchValue) {
                query += `&searchValue=${searchValue}`;
            }
            url += query;
            return this.http.get(url);
        }
    }
}
